"use client";
import { memo } from "react";
import Image from "next/image";
import Marquee from "react-fast-marquee";

import s from "./styles.module.css";

import ETH from "@public/tokens/ETH.svg";
import USDT from "@public/tokens/TETHER.svg";
import BNB from "@public/tokens/BNB.svg";
import USDC from "@public/tokens/USDC.svg";
import WBTC from "@public/tokens/WBTC.svg";
import LINK from "@public/tokens/LINK.svg";
import UNISWAP from "@public/tokens/UNISWAP.svg";
import DAI from "@public/tokens/DAI.svg";
import NEAR from "@public/tokens/NEAR.svg";
import SWEAT from "@public/tokens/SWEAT.svg";
import PEPE from "@public/tokens/PEPE.svg";
import OKB from "@public/tokens/OKB.svg";
import ONDO from "@public/tokens/ONDO.svg";
import AAVE from "@public/tokens/AAVE.svg";
import GATE from "@public/tokens/GATE.svg";
import MNT from "@public/tokens/MNT.svg";
import CRO from "@public/tokens/CRO.svg";
import POL from "@public/tokens/POL.svg";
import ENA from "@public/tokens/ENA.svg";
import SONIC from "@public/tokens/SONIC.svg";
import ARB from "@public/tokens/ARB.svg";
import OP from "@public/tokens/OP.svg";
import KCS from "@public/tokens/KCS.svg";
import QNT from "@public/tokens/QUANT.svg";
import NEXO from "@public/tokens/NEXO.svg";
import BASE from "@public/tokens/BASE.svg";

type TokenItem = {
  ticker: string;
  title: string;
  img: string;
};

// manually/LLM generated for better control and avoiding complex calculations
const row1: TokenItem[] = [
  { ticker: "OKB", title: "OKB", img: OKB },
  { ticker: "AAVE", title: "Aave", img: AAVE },
  { ticker: "MNT", title: "Mantle", img: MNT },
  { ticker: "CRO", title: "Cronos", img: CRO },
  { ticker: "POL", title: "POL", img: POL },
  { ticker: "ENA", title: "Ethena", img: ENA },
  { ticker: "S", title: "Sonic", img: SONIC },
  { ticker: "OP", title: "Optimism", img: OP },
];
const row2: TokenItem[] = [
  { ticker: "QNT", title: "Quant", img: QNT },
  { ticker: "ARB", title: "Arbitrum", img: ARB },
  { ticker: "USDT", title: "Tether", img: USDT },
  { ticker: "BNB", title: "BNB", img: BNB },
  { ticker: "LINK", title: "Chainlink", img: LINK },
  { ticker: "DAI", title: "Dai", img: DAI },
  { ticker: "NEAR", title: "NEAR", img: NEAR },
  { ticker: "SWEAT", title: "SWEAT", img: SWEAT },
  { ticker: "NEXO", title: "Nexo", img: NEXO },
];
const row3: TokenItem[] = [
  { ticker: "KCS", title: "KuCoin", img: KCS },
  { ticker: "ETH", title: "Ethereum", img: ETH },
  { ticker: "USDC", title: "USDC", img: USDC },
  { ticker: "WBTC", title: "Wrapped Bitcoin", img: WBTC },
  { ticker: "ONDO", title: "Ondo", img: ONDO },
  { ticker: "GT", title: "Gate", img: GATE },
  { ticker: "PEPE", title: "Pepe", img: PEPE },
  { ticker: "UNI", title: "Uniswap", img: UNISWAP },
  { ticker: "BASE", title: "Base", img: BASE },
];

const carouselData = [row1, row2, row3];

const getSpeed = (index: number): number => {
  if (index === 0) {
    return 10;
  }

  return index * 4 + 10;
};

const Token = memo(function Token({ ticker, title, img }: TokenItem) {
  return (
    <div className={s.item}>
      <Image src={img} alt={ticker} width={32} height={32} />
      <div className={s.tokenTitle}>{title}</div>
    </div>
  );
});

export default function TokensCarousel() {
  return (
    <div className={s.container}>
      {carouselData.map((row, index) => {
        return (
          <Marquee
            key={index}
            className={s.marquee}
            speed={getSpeed(index)}
            gradient={true}
            gradientColor="black"
            direction={index % 2 === 0 ? "right" : "left"}
          >
            {row.map((token) => (
              <Token {...token} key={token.title} />
            ))}
          </Marquee>
        );
      })}
    </div>
  );
}
